import OperationIndex from './Index'
import OperationView from './View'

export default [
  {
    path: '/operation',
    name: 'operation',
    component: OperationIndex,
    meta: {
      auth: true,
      permission: 'view operation',
    },
  },
  {
    path: '/operation/:energetics_id',
    name: 'operationView',
    component: OperationView,
    meta: {
      auth: true,
      permission: 'view operation',
    },
  },
]
